import React from 'react';
import { Provider } from 'react-redux';

import ThirdPartyIntegrations from './ThirdPartyIntegrations';
import store from './store';

interface ThirdPartyIntegrationsProviderProps {
  apiHost?: string;
  currentCustomerGroupUuid?: string;
}

const ThirdPartyIntegrationsProvider: React.FC<
  ThirdPartyIntegrationsProviderProps
> = (props) => {
  return (
    <Provider store={store}>
      <ThirdPartyIntegrations {...props} />
    </Provider>
  );
};

export default ThirdPartyIntegrationsProvider;
